export default "__VITE_ASSET__C1B3ID_M__"